<template>
  <div>
    <v-card flat>
      <v-card-text v-if="credentialList.length == 0">
        <v-alert prominent type="info">You are not currently logged in to any systems.</v-alert>
      </v-card-text>
      <v-card-text v-else>
        <v-alert type="info">Your Logins.</v-alert>
        <v-divider />
        <v-card v-for="(cred,c) in credentialList" :key="`cred-${c}`" flat>
          <v-list-item>
            <v-list-item-avatar color="primary" size="60" tile><v-icon color="white">mdi-lock</v-icon></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{cred["jwt-decode"].app_displayname}}</v-list-item-title>
              <v-list-item-title>{{cred["jwt-decode"].given_name}} {{cred["jwt-decode"].family_name}}</v-list-item-title>
              <v-list-item-subtitle>{{cred["jwt-decode"].unique_name}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn small color="orange" dark :href="cred.logout_url" @click="deleteCredentials(cred['jwt-decode'].appid)">Signout</v-btn>
            </v-list-item-action>
          </v-list-item>
          <!-- <v-list-item v-for="(keyName, i) in Object.keys(cred)" :key="`prop-${i}`">
            <v-list-item-content v-if="keyName != 'jwt-decode'">
              <v-row>
                <v-col sm="2">{{keyName}}</v-col>
                <v-col sm="10">{{cred[keyName]}}</v-col>
              </v-row>              
            </v-list-item-content>
            <v-list-item-content v-else>
              <h2>jwt-decode</h2>
              <v-row v-for="(jwtKeyName, j) in Object.keys(cred['jwt-decode'])" :key="`jwtprop-${j}`">
                <v-col sm="2">{{jwtKeyName}}</v-col>
                <v-col sm="10">{{cred['jwt-decode'][jwtKeyName]}}</v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item> -->
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="$router.go(-1)">Back</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import credentialsMixin from "@/_mixins/credentials-mixin"

export default {
  name: 'Home',
  mixins : [credentialsMixin],
  computed : {
    credentialList()
    {
      return Object.values(this.credentialCache).filter(e => typeof(e) == typeof({}) && !!e);
    },
  },
  methods:{
  }
}
</script>
